// LaylaLink.jsx — Y4: الرابط الواحد «ليلى ←» من أماكن ليلى القديمة إلى تبويبها في صفحة ليلى الواحدة.
import React from "react";

export const LAYLA_TAB_KEY = "tw_layla_tab";

export const openLaylaTab = (tab) => {
  sessionStorage.setItem(LAYLA_TAB_KEY, tab);
  window.dispatchEvent(new CustomEvent("tw-navigate", { detail: { tab: "layla_inst" } }));
  window.dispatchEvent(new CustomEvent("tw-layla-tab", { detail: { tab } }));
};

export function LaylaLink({ tab, label, testId }) {
  return (
    <button type="button" data-testid={testId} onClick={() => openLaylaTab(tab)}
      style={{ background: "none", border: "1px solid var(--border)", borderRadius: 999, padding: "6px 14px",
               fontSize: 12.5, fontWeight: 800, color: "var(--brown-deep)", cursor: "pointer" }}>
      {label} ← ليلى
    </button>
  );
}
